import { Button, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { useNavigate, useParams } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import { useMemo, useState } from "react"
import ModalDelete from "../../components/ModalDelete"
import { ScrollLayout } from "../../components/ScrollLayout"
import type { Story } from "../../types"
import { initialValuesStory, validationSchemaStory } from "./StoryCommon"
import StoryForm from "./StoryForm"
import { useDeleteStory, usePartialUpdateStory, usePartialUpdateStoryFormData, useStory } from "../../hooks/stories"
import StoryEditorForm from "./StoryEditorForm"

export default function StoryUpdate() {
  const updateStory = usePartialUpdateStoryFormData()
  const updatePartialStory = usePartialUpdateStory()
  const navigate = useNavigate()

  const { id } = useParams()

  const { data: story } = useStory(Number(id))

  const deleteStory = useDeleteStory()

  const [modalStateDeleteStory, modalActionsDeleteStory] = useModalTrigger()

  const initialValues = useMemo(() => initialValuesStory(story), [story])
  const validationSchema = useMemo(() => validationSchemaStory(), [])

  const [activeTab, setActiveTab] = useState("dettaglio")

  useBreadcrumbs([{ label: "Storie", href: "/stories/stories" }, { label: "Dettaglio Storia" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex alignItems="center" justifyContent="between">
          <H1>{story?.title}</H1>
          <Flex alignItems="center" gap={2}>
            {activeTab === "dettaglio" && (
              <Button
                size="md"
                variant="danger"
                title="Elimina"
                leadingIcon="delete"
                onClick={() => {
                  modalActionsDeleteStory.open()
                }}
              />
            )}
            
          </Flex>
        </Flex>
        <ScrollLayout.Tabs
          className="mt-6"
          onTabChange={(tab) => {
            setActiveTab(tab)
          }}
          initialTab="dettaglio"
        >
          <ScrollLayout.Tab id="dettaglio" label="Dettaglio" key={"dettaglio"}>
            <Formik
              enableReinitialize
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(values) => {
                if (typeof values.cover === "string") {
                  delete values.cover
                }
                return updateStory.mutateAsync(values as Story).then(() => {
                  navigate(`/stories/stories`)
                })
              }}
            >
              {({ handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                    <StoryForm />
                  </Container>
                  <BottomFormFixed url="/stories/stories" />
                </form>
              )}
            </Formik>
          </ScrollLayout.Tab>
          <ScrollLayout.Tab id="contenuti" label="Contenuti" key={"contenuti"}>
            <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
              <StoryEditorForm
                fieldName="data"
                onSave={(d) => {
                  updatePartialStory.mutate({
                    id: Number(id),
                    data: d,
                  })
                }}
                currentValue={story?.data || []}
              />
            </Container>
          </ScrollLayout.Tab>
        </ScrollLayout.Tabs>
      </ScrollLayout>

      <ModalDelete
        isOpen={modalStateDeleteStory.isOpen}
        onClose={modalActionsDeleteStory.close}
        onDelete={() => {
          return deleteStory.mutateAsync(story?.id).then(() => {
            navigate(`/stories/stories`)
          })
        }}
        message="Sei sicuro di voler eliminare la storia?"
        title="Elimina Storia"
      />
    </Layout>
  )
}
